// Modules
import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";

// CSS
import '_Asset/css/Admin/Page/admin.css'

// API
import { AdKmCatApi, AdSupportCatApi } from "_Route/Api";


const AdKMSpaceDt = () => {

  // Using Hooks
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const useGroup = ['미사용', '사용'];

  const curType = params.id === 'add' ? {name: '등록', method: 'POST'} : {name: '수정', method: 'PUT'};
  const curScore = params.id === 'add' ? 200 : 300;
  const userName = useSelector(state => state.authorityAcc.name);
  const master = useSelector(state => state.authorityAcc.master);

  const sessionID = localStorage.getItem('memSessionID')
  const userScore = useSelector(state => state.authorityAcc.access_score);
  // const userRoles = useSelector(state => state.authorityAcc.roles);

  const [info, setInfo] = useState({
    ...(curType.name === '수정' && { kmgrp_uuid: '' }),
    km_grp: '',
    kmgrp_create_user: userName,
    kmgrp_last_modify_user: userName,
    kmgrp_use: 1,
    approve_spec_status: 0,
    approve_ap_status: 0,
  })
  const { km_grp, kmgrp_use } = info;

  const curDate = moment(new Date()).format('YYYY-MM-DD HH:mm');


  /*========================================================================
  * Input onChange Func
  ========================================================================*/
  const onChange = (e) => {
    const { name, value } = e.target;
    setInfo({...info, [name]: value});
  }


  /*========================================================================
  * Set Current cust List
  ========================================================================*/
  useEffect(() => {
    axios({
      url: AdKmCatApi,
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
    })
    .then(res => {
      // console.log(res, "KM Category List GET Success!")
      const r = res.data.result;
      const curSpace = r.find(key => key.kmgrp_uuid === params.id)

      if(curSpace === undefined && params.id !== 'add') {
        navigate('/404');
      }
      else {
        if (curType.name === '수정') {
          Object.entries(curSpace).map(key => {
            if(Object.keys(info).includes(key[0])) {
              info[key[0]] = key[1]
            }
          })
          setInfo({...info})
        }
      }
    })
    .catch(err => {
      console.error(err, "KM Category List GET Error...");
    })
  }, [location])


  /*========================================================================
  * Service Axios (POST, PUT, DELETE)
  ========================================================================*/
  const axiosSpc = (curName, curMethod) => {
    axios({
      url: AdKmCatApi,
      method: curMethod,
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: curName === '삭제' ? { kmgrp_uuid: params.id, approve_spec_status: 0, approve_ap_status: 0, } : info
    })
    .then(res => {
      // console.log(res, `KM Category List ${curMethod} Success!`)
      alert(`카테고리 ${curName}${master === 1 ? '' : ' 요청'}을 완료하였습니다.`)
      navigate('/admin/km/space-list')
    })
    .catch(err => {
      // alert(err.response.data.result)
      console.error(err, `KM Category List ${curMethod} Error..`)
      const errMsg = err.response.data.message
      if (errMsg) { alert(errMsg) }
    })
  }


  return (
    <>
      <div className="adContTitGroup">
        <h2>KM 카테고리 {curType.name}</h2>
        <p>Home / KM / KM 카테고리 관리 / KM 카테고리 {curType.name}</p>
      </div>

      <div className="adContArea detail">
        <fieldset className="left">
          <legend>카테고리 등록 및 수정</legend>

          {/* 사용여부 [kmgrp_use] */}
          <div className="fieldGroup row">
            <label>사용여부<span className="redTxt">*</span></label>

            <div className="field">
              {useGroup.map((item, i) =>
                <div className="checkGroup" key={i}>
                  <input type="radio" className="check sm blue" name="kmgrp_use" id={`kmgrp_use_${i}`} value={i} onChange={(e) => onChange(e)} checked={Number(kmgrp_use) === i}/>
                  <label htmlFor={`kmgrp_use_${i}`}></label>

                  <label htmlFor={`kmgrp_use_${i}`}>{item}</label>
                </div>
              )}
            </div>
          </div>

          {/* 카테고리 명 [km_grp] */}
          <div className="fieldGroup row">
            <label>카테고리 명<span className="redTxt">*</span></label>

            <div className="field">
              <input type="text" className="input md round_10" name="km_grp" onChange={(e) => onChange(e)} value={km_grp} placeholder="카테고리 명을 입력해주세요." />
            </div>
          </div>

          {/* 등록/수정 일시 */}
          <div className="fieldGroup row">
            <label>{curType.name} 일시</label>

            <div className="field full">
              <input type="text" className="input md round_10" value={curDate} disabled />
            </div>
          </div>
        </fieldset>

        <div className="btnArea">
          {
            userScore >= curScore &&
            <button type="button" className="btn sm sfrtBlue round_10" onClick={() => axiosSpc(curType.name, curType.method)}>{curType.name}{master === 1 ? '' : ' 요청'}</button>
          }
          <button type="button" className="btn sm blue_edge round_10" onClick={() => navigate('/admin/km/space-list')}>취소</button>
          {curType.name === '수정' && userScore >= 300 && <button type="button" className="btn sm red round_10" onClick={() => {if(window.confirm(`정말 해당 카테고리를 삭제하시겠습니까?`)) axiosSpc('삭제', 'DELETE') }}>{`삭제${master === 1 ? '' : ' 요청'}`}</button>}
        </div>
      </div>
    </>
  )
}

export default AdKMSpaceDt;